import { z } from "zod";

export const PostCategory = {
	NEWS: "news",
	CERTIFICATION: "certification",
	APPOINTMENT: "appointment",
	ANNOUNCEMENT: "announcement",
} as const;

export type PostCategory = (typeof PostCategory)[keyof typeof PostCategory];

export const POST_CATEGORIES = Object.values(PostCategory) as readonly PostCategory[];

export const postCategorySchema = z.enum(PostCategory);
